<template>
  <div>
    <breadcrumbs :home="fermenter.name + ': Reduce inventory'"/>

    <v-card flat>
      <v-form v-model="valid" ref="form" :disabled="!edit">
        <v-container class="pt-6 px-6 purtrak-scrollable" fluid>

            <v-row dense>
              <v-col cols="6" sm="4" lg="3">
                <date-picker v-model="transaction.date" @change="refresh"/>
              </v-col>
            </v-row>

            <v-row dense>
              <v-col cols="6" sm="3" lg="2">
                <decimal-number-input label="Reduce by" v-model="transaction.volume" :precision="0" prefix="" suffix="litres" integer
                              :hint="$number(fermenter.contents.volume) + ' litres'"/>
              </v-col>
              <v-col cols="6" sm="3" lg="2">
                <decimal-number-input label="Total value to reduce" v-model="value" :disabled="calculateValue"/>
              </v-col>
              <v-col cols="6" sm="3" lg="2">
                <v-checkbox label="Calculate value" v-model="calculateValue" dense class="mt-1"/>
              </v-col>
            </v-row>

            <v-row v-if="values && company.connectedToAccounting">
              <v-col cols="12" sm="6" lg="4">
                <account-picker v-model="transaction.expenseAccountRef" label="Inventory adjustment account"
                                :accounts="accounts"
                                hint="An account to balance the inventory asset account. Usually an inventory shrinkage expense or cost of goods account."/>
              </v-col>
            </v-row>
            <v-row >
              <v-col>
                <v-text-field label="Comments" v-model="transaction.comments" outlined dense :rules="[fieldRules.maxLength(255)]" counter="255"/>
              </v-col>
            </v-row>
          </v-container>
      </v-form>
      <v-divider/>
      <v-card-actions class="px-6">
        <v-switch v-if="transactionId && company.permissions.includes('production.write')"
                  v-model="edit" label="Edit" hide-details class="mt-0" :disabled="dirty"/>
        <v-spacer/>
        <v-btn :plain="edit" color="primary" @click="cancel">{{edit?'Cancel':'Done'}}</v-btn>
        <v-btn v-if="edit" color="primary" :loading="saving" @click="save">Save</v-btn>
      </v-card-actions>
    </v-card>

    <confirm-leave v-model="next"/>
  </div>
</template>

<script>
import {format} from 'date-fns'
import confirmLeave from '@/mixins/confirmLeave'

export default {
  name: 'EquipmentFermentersReduceInventory',
  mixins: [confirmLeave],
	props: {
    fermenterId: {type:String,required:false},
    transactionId: {type:String, required:false}
	},
	data() {
		return {
      init: true,
      edit: false,
      fermenter: {name:'',contents:{volume:0}},
      valid:true,
      saving:false,
      accounts: [],
      calculateValue: true,
      value: 0,
      transaction: {fermenterId:this.fermenterId, date: format(new Date(), 'yyyy-MM-dd HH:mm:ss'),
                    volume: 0, value:null, comments: 'Production loss',expenseAccountRef:''},
      dirty: false
		}
  },
  computed: {
    company() {
      return this.$store.getters.company;
    },
    values() {
      return this.$store.getters.company.permissions.includes('values') && this.$store.getters.company.settings.useAccounts;
    }
  },
  watch: {
    calculateValue() {
      if (this.calculateValue)
        this.transaction.value = null;
    },
    transaction: {
      handler() {
        this.dirty = true;
        if (this.calculateValue)
          this.value = this.fermenter.contents.volume ? this.fermenter.contents.value * this.transaction.volume / this.fermenter.contents.volume : 0;
      },
      immediate: true,
      deep: true
    }
  },
	async created() {
    const results = await this.$apiCall(`query EquipmentFermentersReduceInventory($currency:String!,$id:ID!,$edit:Boolean!) {
                                              accounts(currency:$currency) {
                                                ref,parentRef,name,type,typeName
                                              }
                                              fermenterReduceInventory(id:$id) @include(if:$edit) {
                                                fermenterId,date,volume,value,comments,expenseAccountRef
                                              }
                                              companyAccounts @skip(if:$edit) {inventoryAdjustment}
                                            }`,
                                        {currency:this.company.settings.homeCurrency,
                                         id:this.transactionId||'',edit:this.transactionId!=undefined});
    if (results.error) {
      this.$nextTick(() => this.dirty = false);
      this.$router.back();
      return;
    }
    this.accounts = results.data.accounts;
    if (this.transactionId) {
      this.transaction = results.data.fermenterReduceInventory;
      this.transaction.id = this.transactionId;
    }
    await this.refresh();
    if (!this.transactionId) {
      this.transaction.expenseAccountRef = results.data.companyAccounts.inventoryAdjustment;
      this.edit = true;
      this.$nextTick(() => {
        this.$refs.form.validate();
      });
    }
    this.$nextTick(() => this.dirty = false);
    this.init = false;
  },

	methods: {
    async refresh() {
      const results = await this.$apiCall(`query EquipmentFermentersReduceInventory($id:ID!,$date:DateTime!) {
                                                fermenter(id:$id) {
                                                  id,name,contents(date:$date) {volume,value}
                                                }
                                              }`,
                                          {id:this.transaction? this.transaction.fermenterId : this.fermenterId,date:this.transaction.date});
      if (!results.error) {
        this.fermenter = results.data.fermenter;
        this.$nextTick(() => {
          this.$refs.form.validate();
        })
      }
    },
    cancel() {
      this.$router.back();
    },
		async save() {
      if (this.valid) {
        this.transaction.value = this.calculateValue ? null : this.value;
        this.saving = true;
        const results = await this.$apiCall(`mutation EquipmentFermentersReduceInventory($input: FermenterReduceInventoryInput!) {
                                                fermenterReduceInventoryCreate(input:$input) {id}
                                              }`,
                                            {input:this.transaction});
        this.saving = false;
        if (!results.error) {
          this.dirty = false;
          this.$router.back();
          this.$store.commit('setError', {type:'success',message:`${this.transactionId?'Updated':'Created'} reduce inventory transaction for ${this.fermenter.name}`});
        }
      }
		}
	}
}
</script>